import { CommentCommunication } from '@seen/core/models/communications/CommentCommunication'
import { createReferenceStringWithHistory } from '@seen/core/references'
import { sortBy } from 'lodash-es'
import type { ReactNode } from 'react'
import { ActivityEntry } from '#src/components/activity/ActivityEntry.tsx'
import { RichText } from '#src/components/RichText.tsx'
import { useResourceVersions } from '#src/hooks/useResourceVersions.ts'

export function useCommentCommunicationActivity(
  comment: CommentCommunication
): ReactNode[] {
  const { data: pastComments = [] } = useResourceVersions(
    CommentCommunication,
    comment.id
  )

  const ascendingComments = sortBy(pastComments, (a) => a.lastUpdated)

  const ascendingActivity: {
    comment: CommentCommunication
    node: ReactNode
  }[] = []
  ascendingComments.forEach((c, idx) => {
    const prevComment = ascendingActivity.at(-1)?.comment
    if (prevComment?.message === c.message) {
      return
    }
    ascendingActivity.push({
      comment: c,
      node: (
        <ActivityEntry
          key={createReferenceStringWithHistory(c.toFhirResource())}
          author={c.lastUpdatedBy}
          time={c.lastUpdated}
          action={idx === 0 ? 'created' : 'edited'}
        >
          <RichText value={c.message} />
        </ActivityEntry>
      ),
    })
  })

  const activity = ascendingActivity.reverse().map(({ node }) => node)
  return activity
}
